var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-button",
            {
              class: _vm.tableType == 3 ? "ac" : "",
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.changeTable(3)
                }
              }
            },
            [_vm._v("活动数据")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              class: _vm.tableType == 2 ? "ac" : "",
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.changeTable(2)
                }
              }
            },
            [_vm._v("客服数据")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              class: _vm.tableType == 1 ? "ac" : "",
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.changeTable(1)
                }
              }
            },
            [_vm._v("资料数据")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block" },
        [
          _c("el-date-picker", {
            attrs: {
              type: "daterange",
              "value-format": "yyyy-MM-dd",
              "range-separator": "至",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "picker-options": _vm.pickerOptions
            },
            on: {
              change: function($event) {
                return _vm.getlist()
              }
            },
            model: {
              value: _vm.value,
              callback: function($$v) {
                _vm.value = $$v
              },
              expression: "value"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.build_type,
              expression: "build_type"
            }
          ],
          attrs: { name: "选择楼盘类型" },
          on: {
            change: [
              function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.build_type = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
              function($event) {
                return _vm.filterHandler2()
              }
            ]
          }
        },
        [
          _c("option", { attrs: { value: "住宅" } }, [_vm._v(" 住宅")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "公寓" } }, [_vm._v(" 公寓")])
        ]
      ),
      _vm._v(" "),
      _c("SjAndYuny", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.tableType == 1,
            expression: "tableType == 1"
          }
        ],
        attrs: {
          person: _vm.person,
          finishCount: _vm.finishCount,
          build_type: _vm.build_type,
          tableType: _vm.tableType,
          districts: _vm.districts,
          userAll: _vm.userAll
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tableType == 2,
              expression: "tableType == 2"
            }
          ]
        },
        [
          !_vm.value2
            ? _c("div", [_vm._v("未选定时间，默认展示最近一天")])
            : _vm._e(),
          _vm._v(" "),
          _vm.value2
            ? _c("div", [
                _vm._v(
                  "\n      已选时间:开始时间:" +
                    _vm._s(_vm.value2[0]) +
                    "结束时间:" +
                    _vm._s(_vm.value2[1]) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-table",
            { attrs: { data: _vm.kefu } },
            [
              _c("el-table-column", {
                attrs: {
                  filters: _vm.filterList11,
                  "filter-method": _vm.filterHandler1,
                  label: "日期",
                  prop: "date"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { label: "人员", prop: "name" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "群聊活跃个数", prop: "chat_num" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "群聊活跃比例", prop: "chat_rate" }
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "主动" } },
                [
                  _c(
                    "el-table-column",
                    { attrs: { label: "主动联系" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "私聊人数",
                          prop: "active_user",
                          sortable: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "私聊条数",
                          prop: "active_talk",
                          sortable: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "群聊条数",
                          prop: "group_talk",
                          sortable: ""
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    { attrs: { label: "客户回复" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "回复人数",
                          prop: "active_reply_user",
                          sortable: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "回复条数",
                          prop: "active_reply_talk",
                          sortable: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "回复率",
                          prop: "active_reply_rate",
                          sortable: ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "被动" } },
                [
                  _c(
                    "el-table-column",
                    { attrs: { label: "咨询" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "总人数",
                          prop: "passive_user",
                          sortable: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "回复人数",
                          prop: "passive_reply_user",
                          sortable: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "完成率",
                          prop: "passive_reply_rate",
                          sortable: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "速度",
                          prop: "passive_reply_speed",
                          sortable: ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(row["passive_reply_speed"] + "s")
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "深度",
                          prop: "passive_reply_depth",
                          sortable: ""
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    { attrs: { label: "问答" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "总人数",
                          prop: "ask_user",
                          sortable: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "回复人数",
                          prop: "ask_reply_user",
                          sortable: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "完成率",
                          prop: "ask_reply_rate",
                          sortable: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "速度",
                          prop: "ask_reply_speed",
                          sortable: ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                _c("div", [
                                  _vm._v(_vm._s(row["ask_reply_speed"] + "s"))
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "深度",
                          prop: "ask_reply_depth",
                          sortable: ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "顾问联系" } },
                [
                  _c("el-table-column", {
                    attrs: { label: "私聊人数", prop: "guwen_user" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "私聊条数", prop: "guwen_talk" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("el-table-column", { attrs: { label: "积分" } })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tableType == 3,
              expression: "tableType == 3"
            }
          ]
        },
        [
          !_vm.value3
            ? _c("div", [_vm._v("未选定时间，默认展示最近一天")])
            : _vm._e(),
          _vm._v(" "),
          _vm.value3
            ? _c("div", [
                _vm._v(
                  "\n      已选时间:开始时间:" +
                    _vm._s(_vm.value3[0]) +
                    "结束时间:" +
                    _vm._s(_vm.value3[1]) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-table",
            { attrs: { data: _vm.activity } },
            [
              _c("el-table-column", {
                attrs: {
                  filters: _vm.filterList11,
                  "filter-method": _vm.filterHandler1,
                  label: "日期",
                  prop: "date"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "人员",
                  filters: _vm.filterList12,
                  "filter-method": _vm.filterHandler1,
                  prop: "userName"
                }
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "销售" } },
                [
                  _c(
                    "el-table-column",
                    { attrs: { label: "活动" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "分享人数",
                          prop: "activityShareNum",
                          sortable: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "参与人数",
                          prop: "joinActivityNum",
                          sortable: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "参与比例",
                          prop: "activityRate",
                          sortable: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "活动个数",
                          prop: "activityNum",
                          sortable: ""
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    { attrs: { label: "爆点" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "分享人数",
                          prop: "saleShareNum",
                          sortable: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "参与人数",
                          prop: "joinNum",
                          sortable: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "参与比例", prop: "rate", sortable: "" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "客户" } },
                [
                  _c(
                    "el-table-column",
                    { attrs: { label: "爆点" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "分享人数",
                          prop: "customerShareNum",
                          sortable: ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c4ece3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c4ece3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/yunYincount.vue
// module id = null
// module chunks = 